window.procRegSubmt = function () {
  $('#SisSubmitModal').modal('show');
  document.getElementById("MainForm").submit();
};
